/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2015, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
angular.module('bulbApp.shareModule')

/**
 * BulbShareService handles sharing of pages and collections via various social site integrations.
 */
.service('BulbShareService', ['$q', '$translate', '$window', 'Restangular', 'BulbAuthService', 'BulbBusyService',
              'BulbModalService', 'BulbShareableLinkService', 'CONFIG', 'SHARE', BulbShareService]);

function BulbShareService($q, $translate, $window, Restangular, BulbAuthService, BulbBusyService,
  BulbModalService, BulbShareableLinkService, CONFIG, SHARE) {

  var that = this;

  this.displayShareDialog = function($event) {
    var options = {
      template: '<bulb-share></bulb-share>',
      windowClass: 'bulb-share-modal',
      focusAfterClosed: $event.currentTarget
    };
    BulbModalService.showCustomModal(options);

  };

  this.getShareUrl = function(unit, destination) {
    // get the current base url without any query parameters
    var path = $window.location.pathname;

    // add the campaign parameters:
    path += '?utm_source=' + BulbAuthService.currentUser.username +
      '&utm_medium=share' +
      '&utm_campaign=' + destination +
      '&utm_content=' + unit.id;

    return `${CONFIG.base.url}${path}`;
  };

  /**
   * Share the page we get the URL.
   * @param unit
   * @param destination
   */
  this.share = function (unit, destination) {
    const url = this.getShareUrl(unit, destination);
    that.createSharePopUpWindow(unit, url, destination);
  };

  /**
   * Share to google classroom and generate the private link if not available.
   * @param unit
   * @param destination
   */
  this.shareToGoogleClassRoom = function(unit, destination){

    // If private shareable link not available generate the link.
    if(!unit.shareableLink) {
      BulbShareableLinkService.generateShareableLink().then(function(shareableLink){
        var url = CONFIG.base.url + '/u/' + unit.path + '?sharedLink=' + shareableLink;
        that.createSharePopUpWindow(unit, url, destination);
      });
    } else {
      var url = CONFIG.base.url + '/u/' + unit.path + '?sharedLink=' + unit.shareableLink;
      that.createSharePopUpWindow(unit, url, destination);
    }
  };

  /**
   * Create the share popUp Window
   * fix the height and width of popUp Window
   * @param unit
   * @param url
   * @param destination
   */
  this.createSharePopUpWindow = function(unit, url, destination) {

    var w = 600;
    var h = 500;
    var aliasUrl = encodeURIComponent(url);
    var link;
    // some sites have different recommended heights and widths
    switch(destination) {
      case SHARE.FACEBOOK:
        w = 626;
        h = 436;
        link = 'https://www.facebook.com/sharer/sharer.php?u=' + aliasUrl;
        break;
      case SHARE.TWITTER:
        w = 550;
        h = 420;
        break;
    }

    // some computations to center the popup:
    var dualScreenLeft = 'screenLeft' in $window ? $window.screenLeft : $window.screen.left;
    var dualScreenTop = 'screenTop' in $window ? $window.screenTop : $window.screen.top;
    var left = ($window.screen.width/2)-(w/2) + dualScreenLeft;
    var top = ($window.screen.height/3)-(h/3)+ dualScreenTop;

    switch(destination) {
      case SHARE.FACEBOOK:
        $window.open(
          'https://www.facebook.com/sharer/sharer.php?u=' + aliasUrl,
          '',
          'width=' + w + ',height=' + h + ',top=' + top + ',left=' + left);
        break;
      case SHARE.LINKED_IN:
        $window.open(
          'http://www.linkedin.com/shareArticle?mini=true&url=' + aliasUrl,
          '',
          'width=' + w + ',height=' + h + ',top=' + top + ',left=' + left);
        break;
      case SHARE.TWITTER:
        $window.open(
          'https://x.com/intent/post?url=' + aliasUrl,
          '',
          'width=' + w + ',height=' + h + ',top=' + top + ',left=' + left);
        break;
      case SHARE.EMAIL:
        var subject = 'email_share_subject';
        var body = 'email_share_body';

        // If current user is not owner of unit, append "_not_owner" to change email subject and body.
        if (unit.ownerUsername !== BulbAuthService.currentUser.username) {
          subject += '_not_owner';
          body += '_not_owner';
        }
        $translate(subject).then(function(emailSubject) {
          $translate(body, {url: url}).then(function (emailBody) {
            $window.location = 'mailto:?subject=' + emailSubject + '&body=' + emailBody;
          });
        });
        break;
      case SHARE.GOOGLE_CLASSROOM:
        $window.open('https://classroom.google.com/share?url='+ aliasUrl,
          '',
          'width=' + w + ',height=' + h + ',top=' + top + ',left=' + left);
        break;
    }
  };
}

